export default "__VITE_ASSET__CI1xyUgh__"